import type { ServerMode } from '@/types/infrastructure'
import styles from './Infrastructure.module.css'
import { OptionCard } from './OptionCard'
import { dedicatedOnlyStatement } from './serverChoiceText'


interface ServerChoiceProps {
  /** "RDS server" or "DB server": names the group, which is asked "<server>: Existing or Dedicated?". */
  server: string
  /** The radio group's name. Must be unique on the page. */
  name: string
  value: ServerMode | null
  onChange: (mode: ServerMode) => void
  existingDescription: string
  dedicatedDescription: string
  /** Process Pro Global's DB server: Dedicated is the only option, already chosen, with a statement saying why. */
  dedicatedOnly?: boolean
}

/**
 * Existing (use a server that is there already) or Dedicated (create one for this customer), for one server. A labelled group of
 * real radio inputs, so keyboard and screen readers behave natively.
 */
export function ServerChoice({ server, name, value, onChange, existingDescription, dedicatedDescription, dedicatedOnly = false }: ServerChoiceProps) {
  return (
    <fieldset className={styles.cardGroup} role="radiogroup" aria-required="true">
      <legend className={styles.legend}>{server}: Existing or Dedicated?</legend>
      {!dedicatedOnly && (
        <OptionCard name={name} value="existing" checked={value === 'existing'} onChange={() => onChange('existing')} title="Existing" description={existingDescription} />
      )}
      <OptionCard
        name={name}
        value="dedicated"
        checked={dedicatedOnly || value === 'dedicated'}
        onChange={() => onChange('dedicated')}
        title="Dedicated"
        description={dedicatedDescription}
      />
      {dedicatedOnly && <p className={styles.note}>{dedicatedOnlyStatement(server)}</p>}
    </fieldset>
  )
}
